import React from "react";
import { S } from "../styles/tokens";
import PlanBanner from "../components/PlanBanner";
import PricingCards from "../components/PricingCards";

export default function PricingView(props) {
  var user = props.user;
  var userPlan = props.plan;
  return (
    <div style={S.root}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap'); @keyframes spin { to { transform: rotate(360deg); } } * { box-sizing: border-box; margin: 0; padding: 0; } body { background: #f7f3ee; }`}</style>
      <header style={S.header}>
        <div style={S.logoRow} onClick={props.onHome}>
          <div style={S.logoMark}>
            <svg viewBox="0 0 22 22" fill="none" width={17} height={17}>
              <path d="M11 2L19 6.5V15.5L11 20L3 15.5V6.5L11 2Z" stroke="#f7f3ee" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M11 7V11L14 13" stroke="#c9963a" strokeWidth="1.5" strokeLinecap="round" />
              <circle cx={11} cy={11} r={1.8} fill="#c9963a" />
            </svg>
          </div>
          <div>
            <div style={S.logoName}>SYNTRIX</div>
            <div style={S.logoTag}>AI RESUME INTELLIGENCE</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <button style={{ ...S.hBtn, color: "#7a6e64", background: "transparent" }} onClick={props.onBackToDashboard}>← Back to Dashboard</button>
        </div>
      </header>
      {user && <PlanBanner plan={userPlan} user={user} onSignOut={props.onSignOut} />}
      <div style={{ ...S.wrap, paddingTop: 60, paddingBottom: 80 }}>
        <div style={S.secHd}>
          <div style={S.secEye}>UPGRADE</div>
          <div style={S.secTitle}>Choose Your Plan</div>
          <div style={S.secSub}>Every plan includes a 7-day money-back guarantee. No contracts.</div>
        </div>
        {/* Highlight current plan */}
        {userPlan !== "free" && (
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(107,143,113,.08)", border: "1px solid rgba(107,143,113,.25)", borderRadius: 100, padding: "8px 18px", fontSize: 12, color: "#6b8f71" }}>
              ✓ You are currently on the <strong>{userPlan.toUpperCase()} plan</strong>
            </div>
          </div>
        )}
        <PricingCards user={user} onNeedAuth={props.onNeedAuth} />
        <div style={{ textAlign: "center" }}>
          <button onClick={props.onBackToDashboard} style={{ background: "transparent", border: "1px solid rgba(180,160,140,0.28)", color: "#7a6e64", fontFamily: "inherit", fontSize: 11, letterSpacing: 2, padding: "10px 26px", borderRadius: 100, cursor: "pointer" }}>
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
